import Idle from './Idle';

import { Time } from 'ohzi-core';
import { Math as TMath } from 'three';

export default class Animating
{
  constructor()
  {
    this.name = 'animating';
    this.t = 0;
    this.easing_function_t = 0;
  }

  on_enter(animator)
  {
  }

  update(animator)
  {
    this.t += Time.delta_time / animator.duration;

    this.easing_function_t = TMath.clamp(this.t, 0, 1);
    this.easing_function_t = animator.easing_function(this.easing_function_t);

    animator.set_property_value(TMath.lerp(animator.from, animator.to, this.easing_function_t));

    if (this.easing_function_t >= 0.9999)
    {
      animator.set_property_value(animator.to);
      animator.set_current_state(new Idle());
    }
  }

  is_animating()
  {
    return true;
  }

  on_exit(view)
  {

  }
}
